"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/ExpiredPasswordNotice/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _components = require('web/screens/Login/components');
var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');







const ExpiredPasswordNotice = ({ gotoUsernameLogin, variant = 'email-sent' }) => {
  return (
    _react2.default.createElement(_components.FormWrapper, { title: "Your password has expired"   , onBack: gotoUsernameLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
      , _react2.default.createElement('span', { className: "auth-icon-circle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}, _react2.default.createElement(_AuthFrame.MailIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}} ))
      ,  variant === 'no-email'
        ? (
            _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}, "Your password has expired and needs to be reset. This account has no verified email address, so contact BloomText support to reset it."


            )
          )
        : (
            _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}, "Your password has expired and needs to be reset. We have sent you an email with instructions for resetting your password."


            )
          )
      , _react2.default.createElement(_Form.Button, { onClick: gotoUsernameLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "Back to login"  )
    )
  )
}

exports. default = ExpiredPasswordNotice
